import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Invoices_ShellService } from './Invoices.shell.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Invoices_LocalizationService } from './Invoices.localization.service';
import { Invoices_commodity_price_flat_grid_ComponentContextService } from './Invoices.commodity_price_flat_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Invoices.frontend.types'
import { $frontendTypes as $types} from './Invoices.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IInvoices_commodity_price_flat_gridComponentEntity {
  value1?: number, value2?: number, value3?: number, value4?: number, value5?: number, type?: string, date?: string, date_number?: number}

interface IInvoices_commodity_price_flat_gridComponentInParams {
  names: string[], types?: string[], title?: string}


class Invoices_commodity_price_flat_gridComponentRowModel extends GridRowModel {
  grid: Invoices_commodity_price_flat_gridComponent;
  entity: IInvoices_commodity_price_flat_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    value1: null,
    value2: null,
    value3: null,
    value4: null,
    value5: null,
    type: null,
    date: null,
  }



  constructor(
    grid: Invoices_commodity_price_flat_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Invoices_ShellService,
private $datasources: Invoices_DatasourceService,
private $flows: Invoices_FlowService,
private $reports: Invoices_ReportService,
private $localization: Invoices_LocalizationService,
private $operations: Invoices_OperationService,
private $logger: CleanupLoggerService,
private $context: Invoices_commodity_price_flat_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.value1 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.value1,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.value2 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.value2,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.value3 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.value3,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.value4 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.value4,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.value5 = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.value5,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IInvoices_commodity_price_flat_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.type,this.entity.date].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IInvoices_commodity_price_flat_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.type,this.entity.date].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'type',this.entity.type);
    set($resultKey, 'date',this.entity.date);
    const inParams = {
      $keys:[$resultKey],
      names:  $grid.inParams.names ,
      types:  $grid.filters.type.control.value ? [$grid.filters.type.control.value] : $grid.inParams.types ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.Invoices.ds_commodity_price_flat_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IInvoices_commodity_price_flat_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.value1.displayControl as TextModel).text = $row.entity.value1?.toLocaleString();
    (this.cells.value2.displayControl as TextModel).text = $row.entity.value2?.toLocaleString();
    (this.cells.value3.displayControl as TextModel).text = $row.entity.value3?.toLocaleString();
    (this.cells.value4.displayControl as TextModel).text = $row.entity.value4?.toLocaleString();
    (this.cells.value5.displayControl as TextModel).text = $row.entity.value5?.toLocaleString();
    (this.cells.type.displayControl as TextModel).text = $row.entity.type;
    (this.cells.date.displayControl as TextModel).text = $row.entity.date?.toString();

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: Invoices_commodity_price_flat_gridComponentRowModel,
  $grid: Invoices_commodity_price_flat_gridComponent, 
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_commodity_price_flat_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Invoices', 'commodity_price_flat_grid.on_row_data_loaded');
  //O.Arias - 07/26/2024
  
  const format = `MM/DD/YYYY, LT`;
  
  if ($utils.isDefined(format)) {
      if ($utils.isDefined($row.entity.date)) {
          $row.cells.date.displayControl.text = $utils.date.format($row.entity.date, format);
      }
  }
  
  let value_id: number = 0;
  
  for (let name of $grid.inParams.names) {
  
      value_id++;
  
      if (value_id > 5) { break } //Supporting 5 columns for now
  
      if ($utils.isDefined($row.entity[`value${value_id}`])) {
          let num = $row.entity[`value${value_id}`];
          $row.cells[`value${value_id}`].displayControl.text = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Invoices-commodity_price_flat_grid',
  templateUrl: './Invoices.commodity_price_flat_grid.component.html'
})
export class Invoices_commodity_price_flat_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IInvoices_commodity_price_flat_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IInvoices_commodity_price_flat_gridComponentInParams = { names: [], types: [], title: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     value1: new GridHeaderModel(new HeaderStyles(null, null), 'value1', 'Value1', false, false, null, false),       value2: new GridHeaderModel(new HeaderStyles(null, null), 'value2', 'Value2', false, false, null, false),       value3: new GridHeaderModel(new HeaderStyles(null, null), 'value3', 'Value3', false, false, null, false),       value4: new GridHeaderModel(new HeaderStyles(null, null), 'value4', 'Value4', false, false, null, false),       value5: new GridHeaderModel(new HeaderStyles(null, null), 'value5', 'Value5', false, false, null, false),       type: new GridHeaderModel(new HeaderStyles(null, null), 'type', 'Type', false, false, null, false),       date: new GridHeaderModel(new HeaderStyles(null, null), 'date', 'Date', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Invoices_commodity_price_flat_gridComponentRowModel[] = [];

  @Input('names') set $inParams_names(value: any) {
    this.inParams['names'] = value;
  }
  get $inParams_names(): any {
    return this.inParams['names'] ;
  }
  @Input('types') set $inParams_types(value: any) {
    this.inParams['types'] = value;
  }
  get $inParams_types(): any {
    return this.inParams['types'] ;
  }
  @Input('title') set $inParams_title(value: any) {
    this.inParams['title'] = value;
  }
  get $inParams_title(): any {
    return this.inParams['title'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'From', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, '', 'datetime', null)
, new ControlContainerStyles(null, null), 'To', false, false),
    type: new FieldModel(new TextBoxModel(this.formGroup.controls['type'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Invoices_ShellService,
    private $datasources: Invoices_DatasourceService,
    private $flows: Invoices_FlowService,
    private $reports: Invoices_ReportService,
    private $localization: Invoices_LocalizationService,
    private $operations: Invoices_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Invoices_commodity_price_flat_grid_ComponentContextService,
    ) {
    super();
    this.title = 'commodity_price_flat_grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.names)) {
        this.$missingRequiredInParams.push('names');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;

    

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      names:  $grid.inParams.names ,
      types:  $grid.filters.type.control.value ? [$grid.filters.type.control.value] : $grid.inParams.types ,
      date_from:  $grid.filters.date_from.control.value ,
      date_to:  $grid.filters.date_to.control.value ,
      full_text_search:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.Invoices.ds_commodity_price_flat_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IInvoices_commodity_price_flat_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Invoices_commodity_price_flat_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Invoices_commodity_price_flat_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Invoices_commodity_price_flat_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_commodity_price_flat_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Invoices', 'commodity_price_flat_grid.on_init');
  //O.Arias - 07/26/2024
  
  //Default for the dates
  
  let date = $utils.date.now();
  
  let new_date = new Date(date);
  new_date.setUTCHours(0, 0, 0, 0);
  date = new_date.toISOString();
  
  $grid.filters.date_from.control.value = $utils.date.subtract(30, "day", date);
  $grid.filters.date_to.control.value = $utils.date.add(1, "day", date);
  
  $grid.headers.value1.hidden = true;
  $grid.headers.value2.hidden = true;
  $grid.headers.value3.hidden = true;
  $grid.headers.value4.hidden = true;
  $grid.headers.value5.hidden = true;
  
  let value_id: number = 0;
  
  for (let name of $grid.inParams.names) {
  
      value_id++;
  
      if (value_id > 5) { break } //Supporting 5 columns for now
  
      $grid.headers[`value${value_id}`].hidden = false;
      $grid.headers[`value${value_id}`].name = name.slice(0, 1).toUpperCase().concat(name.slice(1, name.length).toLowerCase());
  }
  
  $grid.title = $grid.inParams.title ?? "Commodity price flat grid"
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: Invoices_commodity_price_flat_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_commodity_price_flat_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Invoices', 'commodity_price_flat_grid.on_export_flow');
  
  const settingsExcelExportLimit = 5000;
  const serverMaxAllowedRecordsLimit: number = 5000;// could be changed base on what each request to the server can handle.
  const concurrentLimit = 5;//max concurrent requests
  const timeout = 500;//use it only if you want to set a delay between requests...
  // Initialize
  var workBook = $event;
  var recordsToExport = [];
  var fullDataSet: any[] = [];
  
  const names = $grid.inParams.names;
  
  //parameters to be passed to dataset api call
  const baseParams = {
      names: $grid.inParams.names,
      date_from: $grid.filters.date_from.control.value,
      date_to: $grid.filters.date_to.control.value,
      full_tex_search: $grid.fullTextSearch,
      types: $grid.filters.type.control.value ? [$grid.filters.type.control.value] : null
  }
  
  //api call
  const dataApiCall = async (baseParams: any) => {
      return await $datasources.Invoices.ds_commodity_price_flat_grid.getList(baseParams);
  }
  
  //records count api call
  const countApiCall = async (baseParams: any) => {
      const params = { ...baseParams, $top: 0 }
      return await $datasources.Invoices.ds_commodity_price_flat_grid.getList(params);
  }
  
  //api call execution
  async function processApiCall(apiCall: (params: any) => Promise<any>, baseParams: any = {}, offset: number = 0, limit: number = 0): Promise<any> {
      const defaultParams = { $skip: offset, $top: limit }
      // Merge base, default, and additional params
      const params = { ...baseParams, ...defaultParams }
      return await apiCall(params);
  }
  
  //main funcion to handle concurrency in reagard of server and request limits
  async function processControlledApiRequests(totalRecords: number, requestLimit: number, serverLimit: number): Promise<any[]> {
      const totalBatches = Math.ceil(Math.min(totalRecords, serverLimit) / requestLimit);
  
      const result: any[] = [];
      const fetchPromiseQueue: Promise<any[]>[] = [];
  
      for (let i = 0; i < totalBatches; i++) {
          const offset = i * requestLimit;
          const limit = Math.min(requestLimit, serverLimit - (i * requestLimit));
  
          fetchPromiseQueue.push(processApiCall(dataApiCall, baseParams, offset, limit));
  
          //process promiseQueue once reached the limit then clear queue for the next loop round...
          if (fetchPromiseQueue.length === concurrentLimit) {
              result.push(...await Promise.all(fetchPromiseQueue));
              fetchPromiseQueue.length = 0;
          }
      }
  
      // Process any remaining requests after the loop
      if (fetchPromiseQueue.length) result.push(...await Promise.all(fetchPromiseQueue));
  
      return result;
  }
  
  try {
  
      let data: { value1: string, value2: string, value3: string, value4: string, date: string, type: string }[]
  
      if ($grid.selectedRows?.length > 0) {
  
          data = $grid.selectedRows?.map(R => {
              return {
                  value1: R.entity.value1?.toLocaleString(),
                  value2: R.entity.value2?.toLocaleString(),
                  value3: R.entity.value3?.toLocaleString(),
                  value4: R.entity.value4?.toLocaleString(),
                  date: R.entity.date?.toString(),
                  type: R.entity.type?.toString()
              }
          })
  
          if (names?.length >= 4) {
              recordsToExport = map_to_result(names, data);
          } else {
              recordsToExport = data;
          }
  
          var workSheet = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, workSheet, "CommodityPriceList");
      }
      else {
  
          const { totalCount: requestedRecordsCount } = await countApiCall(baseParams);
  
          if (requestedRecordsCount > settingsExcelExportLimit) {
              await $shell.Invoices.openInfoDialog(`Export limitation of ${settingsExcelExportLimit} exceeded`, `Excel will only export ${settingsExcelExportLimit} records`);
          }
  
          const responses = await processControlledApiRequests(requestedRecordsCount, serverMaxAllowedRecordsLimit, settingsExcelExportLimit);
          responses.forEach(apiResponse => {
              fullDataSet.push(...apiResponse.result);
          });
  
          data = fullDataSet?.map(R => {
              return {
                  value1: R.value1?.toLocaleString(),
                  value2: R.value2?.toLocaleString(),
                  value3: R.value3?.toLocaleString(),
                  value4: R.value4?.toLocaleString(),
                  date: R.date?.toString(),
                  type: R.type?.toString()
              }
          })
  
          if (names?.length >= 4) {
              recordsToExport = map_to_result(names, data);
          } else {
              recordsToExport = data;
          }
  
          var ws = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, ws, "CommodityPriceList");
  
      }
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      throw new Error(errorMessage);
  }
  
  
  function map_to_result(names: string[], data: { value1: string, value2: string, value3: string, value4: string, date: string, type: string }[]) {
  
      return data.map(row => {
          const result: Record<string, any> = {};
  
          let i: number = 0;
  
          Object.keys(row).map(K => {
  
              if (i < 4) { result[`${names[i]}`] = row[`${K}`] } else { result[`${K}`] = row[`${K}`] }
  
              i++;
          })
  
          return result;
      });
  }
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'Invoices_commodity_price_flat_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
